export class ContactConstants {
    static ciraConnectPOBoxAddress = `
    P.O. Box 803555
    <br />
    Dallas, TX 75380`;

    static contactUsPhone = '1-855-877-2472';
    static contactUsPhoneDisplayText = '855-877-CIRA(2472), Option #2';
    static contactUsEmail = 'service@ciramail.com';
    static contactSupportUrl = 'ciranet-support';
    static contactIdeaCenterUrl = 'https://ciracloud.atlassian.net/servicedesk/customer/portal/1/group/11/create/10';
}
